module.exports = __webpack_public_path__ + "img/doublepeeps.bbdb9376.png";